import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getAllUsers = async (
  page = 1,
  limit = 10,
  search = "",
  filter = "active",
) => {
  // return api.get(`/user/userType/all?page=${page}&limit=${limit}`);
  const params = {};
  if (page) params.page = page;
  if (limit) params.limit = limit;
  if (search) params.search = search;
  if (filter) params.filter = filter;
  const res = await api.get(networkConfig.users.getAllUsers, { params });
  return res.data;
};

export const getActiveUsers = () => {
  return api.get("/user/userType/active");
};

export const getInactiveUsers = () => {
  return api.get("/user/userType/inactive");
};

export const blockUserApi = async (userId) => {
  // return api.patch(`/user/${userId}/block/true`);
  const res = await api.patch(
    `${networkConfig.users.blockUser}/${userId}/block`,
  );
  return res.data;
};

export const unblockUserApi = async (userId) => {
  // return api.patch(`/user/${userId}/block/false`);
  const res = await api.patch(
    `${networkConfig.users.unblockUser}/${userId}/unblock`,
  );
  return res.data;
};
